export class Route {
  static readonly ProviderNetwork = '/my-network';
  static readonly FacilityCvo = '/facility/cvo-requests';

  static readonly Settings = class {
    static readonly Settings = '/settings';
    static readonly Account = '/settings/account';
    static readonly MyAccount = '/settings/account/my-account';
    static readonly Team = '/settings/account/team';
    static readonly Coverage = '/settings/coverage';
    static readonly CoverageLicense = '/settings/coverage/license';
    static readonly CoverageBoard = '/settings/coverage/board';
    static readonly CredAgent = '/settings/cred-agent';
    static readonly CredAgentInitialCredentialingRules = '/settings/cred-agent/initial-credentialing-rules';
    static readonly CredAgentUsage = '/settings/cred-agent/usage';
    static readonly AuditLogs = '/settings/audit-logs';
    static readonly Sources = '/settings/sources';
    static readonly FeaturePreference = '/settings/feature-preference';
    static readonly Authentication = '/settings/authentication';
    static readonly AuthenticationOAuth = '/settings/authentication/oauth';
    static readonly AuthenticationSSO = '/settings/authentication/sso';
  };
}
